import { Component, Prop, Inject, Watch } from 'vue-property-decorator';
import Vue2Filters from 'vue2-filters';
import { TipoRevision } from '@/shared/model/enumerations/tipo-revision.model';
import { mixins } from 'vue-class-component';
import SolucionMixin from '../mixins/solucion-mixin';
import { IRevision } from '@/shared/model/revision.model';
import { mapMutations } from 'vuex';
import { TipoComision } from '@/shared/model/enumerations/tipo-comision.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { EstadoRevision } from '@/shared/model/enumerations/estado-revision.model';
import SolicitudMixin from '../mixins/solicitud-mixin';
import RevisionMixin from '../mixins/revision-mixin';
import { Solucion } from '@/shared/model/solucion.model';
import HomeMenuComponent from '@/components/home-menu/home-menu.component';

@Component({
  mixins: [Vue2Filters.mixin],
  methods: {
    ...mapMutations([
      'setEvaluacion',
      'setDictamen',
      'setRevisorSeleccionado',
      'setResultadoGralCualitativoFinal',
      'setValoracionesCualitativas',
      'setNivelEvaluacion1',
      'setSumaValoresCualitativos1',
      'setResultadoGralCualitativo1',
      'setValido',
      'setConfirmaNivelSugerido',
      'setSegundaOportunidadUsada',
      'setEvaluacionEmeGuardada1',
      'setValoracionesCualitativasEme',
      'setNivelEvaluacion2',
      'setSumaValoresCualitativos2',
      'setResultadoGralCualitativo2',
      'setSumaValoresCualitativosFinal',
      'setResumen',
      'setSegundaOportunidadActiva',
      'setEsExcepcion',
      'setNivelExcepcion',
      'setJustificacionExcepcion',
      'setEvaluacionEmeGuardadaFinal',
      'setEvaluacionGuardadaFinal',
      'setEvaluacionGuardada1',
    ]),
  },
})
export default class EvaluacionesIndividualesEmeritosComponent extends mixins(
  SolucionMixin,
  SolicitudMixin,
  RevisionMixin,
  HomeMenuComponent
) {
  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({ required: true })
  public revision;

  @Prop({ required: true })
  public solucionDictamen: Solucion;

  public evaluacionId: string;
  public plenariaId: string;

  public revisiones: Array<IRevision> = [];

  public revisada = EstadoRevision.REVISADA;

  public aceptada = EstadoRevision.ACEPTADA;

  public evaluacionEmeGuardadaFinal = false;

  public confirmaClonacion = '';

  /**
   * Mutación para guardar la evaluación seleccionada
   */
  setEvaluacion!: (evaluacion: any) => void;

  /**
   * Mutación para guardar el dictamen seleccionada
   */
  setDictamen!: (dictamen: any) => void;

  /**
   * Mutación para guardar el revisor seleccionado
   */
  setRevisorSeleccionado!: (revisionSeleccionada: number) => void;

  setResultadoGralCualitativoFinal!: (evaluacion: any) => void;

  setValoracionesCualitativas!: (valoracionesCualitativas: any) => void;

  setNivelEvaluacion1!: (nivelEvaluacion1: any) => void;

  setSumaValoresCualitativos1!: (sumaValoresCualitativos1: any) => void;

  setResultadoGralCualitativo1!: (resultadoGralCualitativo1: any) => void;

  setValido!: (valido: any) => void;

  setConfirmaNivelSugerido!: (confirmaNivelSugerido: any) => void;

  setSegundaOportunidadUsada!: (segundaOportunidadUsada: any) => void;

  setEvaluacionEmeGuardada1!: (evaluacionEmeGuardada1: any) => void;

  setValoracionesCualitativasEme!: (valoracionesCualitativasEme: any) => void;

  setNivelEvaluacion2!: (nivelEvaluacion2: any) => void;

  setSumaValoresCualitativos2!: (sumaValoresCualitativos2: any) => void;

  setResultadoGralCualitativo2!: (resultadoGralCualitativo2: any) => void;

  setSumaValoresCualitativosFinal!: (sumaValoresCualitativosFinal: any) => void;

  setResumen!: (resumen: any) => void;

  setSegundaOportunidadActiva!: (segundaOportunidadActiva: any) => void;

  setEsExcepcion!: (esExcepcion: any) => void;

  setNivelExcepcion!: (nivelExcepcion: any) => void;

  setJustificacionExcepcion!: (justificacionExcepcion: any) => void;

  setEvaluacionEmeGuardadaFinal!: (evaluacionEmeGuardadaFinal: any) => void;

  setEvaluacionGuardadaFinal!: (evaluacionGuardadaFinal: any) => void;

  setEvaluacionGuardada1!: (evaluacionGuardada1: any) => void;

  mounted(): void {
    this.get();
  }

  /**
   * Carga inicial del componente
   *
   * @memberof EvaluacionesIndividualesComponent
   */
  public get(): void {
    if (this.solicitud && this.revision) {
      (this.clonado = this.revision?.respuesta?.clonado),
        (this.evaluacionEmeGuardadaFinal = this.revision?.respuesta?.evaluacionEmeGuardadaFinal),
        this.getDefinicionRevision(this.solicitud.solucionId);
    }
  }

  /**
   *Obtiene las definiciones de una revisión
   *
   * @memberof EvaluacionesIndividualesComponent
   */
  @Watch('definicionEvaluacion')
  public getDefiniciones() {
    if (this.solicitud?.reconsideracion) {
      this.plenariaId = this.getDefinicionByTipoComision(TipoRevision.PLENARIA, TipoComision.RECONSIDERACION);
      this.evaluacionId = this.getDefinicionByTipoComision(TipoRevision.INDIVIDUAL, TipoComision.RECONSIDERACION);
    } else {
      this.plenariaId = this.getDefinicionByTipoComision(TipoRevision.PLENARIA, TipoComision.DICTAMINADORA);
      this.evaluacionId = this.getDefinicionByTipoComision(TipoRevision.INDIVIDUAL, TipoComision.DICTAMINADORA);
    }
    this.getTodasRevisiones();
  }

  /**
   *Obtiene las revisiones de una solicitud del cuestionario evaluación individual
   *
   * @memberof EvaluacionesIndividualesComponent
   */
  public getTodasRevisiones() {
    this.revisionService()
      .getAllRevisionesBySolicitudId(this.solicitud.id, this.evaluacionId)
      .then(revisiones => {
        // Filtrar las revisiones por el estado revisada
        this.revisiones = revisiones.filter(revision => revision.estado === this.revisada);
      })
      .catch(err => {});
  }

  /**
   * Establece la evaluación y dictamen de un evaluador en el store para ser recuperado en la evaluación plenaria.
   * Dirige a la evaluación plenaria con un evento de clic
   * @param revision la revisión seleccionada
   */
  public seleccionarRevision(revision: any, index: number) {
    // Mostrar la información de la revisión seleccionada
    this.setEvaluacion(revision?.respuesta?.evaluacion);
    this.setDictamen(revision?.respuesta?.dictamen);
    this.setRevisorSeleccionado(index + 1);
    this.setResultadoGralCualitativoFinal(revision?.respuesta?.resultadoGralCualitativoFinal);
    this.setValoracionesCualitativas(revision?.respuesta?.valoracionesCualitativas);
    this.setNivelEvaluacion1(revision?.respuesta?.nivelEvaluacion1);
    this.setSumaValoresCualitativos1(revision?.respuesta?.sumaValoresCualitativos1);
    this.setResultadoGralCualitativo1(revision?.respuesta?.resultadoGralCualitativo1);
    this.setValido(revision?.respuesta?.valido);
    this.setConfirmaNivelSugerido(revision?.respuesta?.confirmaNivelSugerido);
    this.setSegundaOportunidadUsada(revision?.respuesta?.segundaOportunidadUsada);
    this.setEvaluacionEmeGuardada1(revision?.respuesta?.evaluacionEmeGuardada1);
    this.setValoracionesCualitativasEme(revision?.respuesta?.valoracionesCualitativasEme);
    this.setNivelEvaluacion2(revision?.respuesta?.nivelEvaluacion2);
    this.setSumaValoresCualitativos2(revision?.respuesta?.sumaValoresCualitativos2);
    this.setResultadoGralCualitativo2(revision?.respuesta?.resultadoGralCualitativo2);
    this.setSumaValoresCualitativosFinal(revision?.respuesta?.sumaValoresCualitativosFinal);
    this.setResumen(revision?.respuesta?.resumen);
    this.setSegundaOportunidadActiva(revision?.respuesta?.segundaOportunidadActiva);
    this.setEsExcepcion(revision?.respuesta?.esExcepcion);
    this.setNivelExcepcion(revision?.respuesta?.nivelExcepcion);
    this.setJustificacionExcepcion(revision?.respuesta?.justificacionExcepcion);
    this.setEvaluacionEmeGuardadaFinal(revision?.respuesta?.evaluacionEmeGuardadaFinal);
    this.setEvaluacionGuardadaFinal(revision?.respuesta?.evaluacionGuardadaFinal);
    this.setEvaluacionGuardada1(revision?.respuesta?.setEvaluacionGuardada1);
    // this.setValoracionesCualitativas(revision?.respuesta?.valoracionesCualitativasEme);

    // Se guardan los datos cada vez que se seleccione un evaluador diferente
    this.guardarEvaluacionPleno(revision);

    // simular clic con javascript para llevarte al siguiente paso.
    document.querySelector('#sidebar-wrapper > div > ul > li:nth-child(6) > a').dispatchEvent(new Event('click'));
  }

  /**
   * Método para guardar la evaluación de una revisión.
   * @param revision la revisión que contiene la información.
   */
  public guardarEvaluacionPleno(revision: any): void {
    let revisionPleno = {};

    revisionPleno = {
      evaluacion: revision.respuesta.evaluacion,
      dictamen: revision.respuesta.dictamen,
      resultadoGralCualitativoFinal: revision?.respuesta?.resultadoGralCualitativoFinal,
      valoracionesCualitativasEme: revision?.respuesta?.valoracionesCualitativasEme,
      evaluacionEmeGuardadaFinal: revision?.respuesta?.evaluacionEmeGuardadaFinal,
      nivelEvaluacion1: revision?.respuesta?.nivelEvaluacion1,
      sumaValoresCualitativos1: revision?.respuesta?.sumaValoresCualitativos1,
      resultadoGralCualitativo1: revision?.respuesta?.resultadoGralCualitativo1,
      valido: revision?.respuesta?.valido,
      confirmaNivelSugerido: revision?.respuesta?.confirmaNivelSugerido,
      segundaOportunidadUsada: revision?.respuesta?.segundaOportunidadUsada,
      evaluacionEmeGuardada1: revision?.respuesta?.evaluacionEmeGuardada1,
      nivelEvaluacion2: revision?.respuesta?.nivelEvaluacion2,
      sumaValoresCualitativos2: revision?.respuesta?.sumaValoresCualitativos2,
      resultadoGralCualitativo2: revision?.respuesta?.resultadoGralCualitativo2,
      sumaValoresCualitativosFinal: revision?.respuesta?.sumaValoresCualitativosFinal,
      resumen: revision?.respuesta?.resumen,
      segundaOportunidadActiva: revision?.respuesta?.segundaOportunidadActiva,
      esExcepcion: revision?.respuesta?.esExcepcion,
      nivelExcepcion: revision?.respuesta?.nivelExcepcion,
      justificacionExcepcion: revision?.respuesta?.justificacionExcepcion,
      evaluacionGuardadaFinal: revision?.respuesta?.evaluacionGuardadaFinal,
      evaluacionGuardada1: revision?.respuesta?.evaluacionGuardada1,
    };
    this.guardaEvaluacion(revisionPleno);
  }

  /**
   * Verifica si la revisión está en estado 'aceptada'.
   */
  public get estadoPleno(): boolean {
    return this.revision?.estado === this.aceptada;
  }

  public confirmarClonado(valor: string): void {
    if (valor === 'SI') {
      this.clonado = true;
      this.confirmaClonacion = 'SI';
    } else if (valor === 'NO') {
      this.clonado = false;
      this.confirmaClonacion = 'NO';
      // simular clic con javascript para llevarte al siguiente paso.
      document.querySelector('#sidebar-wrapper > div > ul > li:nth-child(6) > a').dispatchEvent(new Event('click'));
    }

    let datosEnviar = {};

    datosEnviar = {
      confirmaClonacion: this.confirmaClonacion,
      clonado: this.clonado,
    };
    this.guardaEvaluacion(datosEnviar);
  }
}
